export default __webpack_public_path__ + "static/media/bizswoop-logo.cbbfd56d.png";